import { Tag } from "@/themes/ci/blog/types";
import Badge from "./Badge";

const Badges = ({ badges, limit }: { badges: Tag[]; limit: number }) => {
  const renderedBadges = badges
    .slice(0, limit)
    .map((tag, idx) => (
      <Badge
        key={tag.slug + idx}
        link={`/blog/1?tags=${tag.slug}`}
        name={tag.name}
      />
    ));

  const needDots = limit < badges.length;

  return (
    <div>
      {renderedBadges}
      {needDots && <span>...</span>}
    </div>
  );
};

export default Badges;
